import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lenders',
  templateUrl: './lenders.component.html',
  styleUrls: ['./lenders.component.css']
})
export class LendersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
